import { FC, PropsWithChildren } from "react";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer/Footer";

interface PageLayout {
  navbarClassName?: string;
}

const PageLayout: FC<PropsWithChildren<PageLayout>> = ({ children, navbarClassName }: PropsWithChildren<PageLayout>) => {
  /**
   * Holds the Navbar and the Footer
   */
  return (
    <>
      <Navbar className={navbarClassName} />
      <div role="main">{children}</div>
      <Footer />
    </>
  );
};

export default PageLayout;
